







import { Component, Vue, Mixins, Watch } from 'vue-property-decorator'
import mixin from './mixin'

@Component({
	name: 'commonTasksDetail',
})
export default class commonTasksDetail extends Mixins(mixin) {
	private testMethod() {
		// this.$router.push(`/CommonAiiTask/TasksDetail/9267/2`)
		// this.$router.push({
		// 	name: 'AddTaskWithParam',
		// 	params: {
		// 		param: {
		// 			businessId: 'aaa',
		// 			companyId: 'aaa',
		// 			subordinateCode: 'aaa',
		// 			caseNo: 'aaa',
		// 			ownerName: 'aaa',
		// 			ownerPhone: 'aaa',
		// 			carNo: 'aaa',
		// 			provinceCode: 'aaa',
		// 			cityCode: 'aaa',
		// 			countryCode: 'aaa',
		// 			hospital: 'aaa',
		// 			contact: 'aaa',
		// 			contactPhone: 'aaa',
		// 			department: 'aaa',
		// 			injuredName: 'aaa',
		// 			injuredPhone: '13111111111,13222222222,13333333333',
		// 			visitRequest: 'aaa',
		// 		}
		// 	}
		// })
	}
}
